<template>
  <div class="page_main">
    <Spin fix size="large" v-if="table_loading"></Spin>

    <div class="page_tabs">
      <div class="search_div">
        <Input
          v-model="search_value"
          clearable
          search
          @on-enter="search_click"
          size="small"
          placeholder="搜索姓名"
          style="width: 100px"
        />
      </div>

      <div class="tabs_div">
        <Tabs v-if="tabs_show" size="small" :v-model="tabs_index" @on-click="click_tabs">
          <TabPane
            v-for="(item, i) in flow_class_list"
            :key="i"
            :name="item.value"
            :label="item.label"
          >
          </TabPane>
        </Tabs>
      </div>

      <div class="button_operation">
        <div v-if="is_action" class="button_1">
          <Button
            @click="click_action(item)"
            v-for="(item, i) in action_list"
            :loading="button_loading"
            :key="i"
            size="small"
            style="font-size: 12px; margin-right: 10px"
            type="primary"
            >{{ item.label }}
          </Button>
        </div>

        <Button
          @click="click_get_back"
          v-if="tabs_index == 'FLOW_B718E'"
          size="small"
          style="font-size: 12px; margin-left: 10px"
          type="warning"
        >
          <Icon type="ios-arrow-dropleft" /> 返回上一步
        </Button>
      </div>
    </div>

    <div class="table_div">
      <Table
        size="small"
        :height="windowHeight - 185"
        :columns="columns"
        :data="table_data"
        @on-selection-change="tabs_selection_change"
      >
        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>
        <template #belong_name="{ row }"
          ><span class="belong_name" :title="row.belong_phone">{{
            row.belong_name
          }}</span>
        </template>
        <template #idcard="{ row }">
          <span class="idcard2" @click="click_idcard_num(row)">{{ row.idcard }}</span>

          <i
            title="已实名"
            v-if="row.is_certification == 1"
            class="iconfont iconrenzheng"
          ></i>

          <i
            title="未实名"
            v-else
            class="iconfont iconweirenzheng"
            @click="click_update_certification(row)"
          ></i>
        </template>
        <template #create_time="{ row }">
          <span class="idcard_num" @click="click_update_time(row)">{{
            row.create_time
          }}</span>
        </template>
        <template #phone="{ row }">
          <div    @click="click_update_phone(row)">
            <span class="phone_span">{{ row.phone }}</span>

            <Icon
              class="phone_icon"
              type="ios-create-outline"
            />
          </div>
        </template>
        <template #job_name="{ row }">
          <span class="idcard_num" @click="click_job_name(row)"
            >{{ row.job_name }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
        <template #remarks="{ row }">
          <span class="idcard_num" @click="click_update_remarks(row)"
            >{{ row.remarks }}

            <Icon type="ios-create-outline" size="14" color="#0466dd" />
          </span>
        </template>
      </Table>
      <div class="content_page">
        <Page
          show-elevator
          show-total
          :total="total_count"
          v-model="page"
          :page-size="limit"
          @on-change="page_change"
        />
      </div>
    </div>

    <update_idcard @change="update_idcard_change" ref="update_idcard"></update_idcard>

    <Modal
      v-model="update_time_show"
      title="更新入职时间"
      :footer-hide="true"
      width="300"
    >
      <div class="time_picker">
        <DatePicker
          v-model="update_time_data.create_time_date"
          type="datetime"
          placeholder="Select date and time"
          style="width: 250px"
        />
      </div>

      <div class="click_update_time_button">
        <Button type="primary" @click="click_update_time_button">确认更新</Button>
      </div>
    </Modal>

    <Modal v-model="lizhi_show" title="确认离职" :footer-hide="true" width="400">
      <Alert type="error">保险部重要提示：离职请记得系统提报减员！！</Alert>
      <div class="time_picker">
        <Input
          v-model="lizhi_remarks"
          maxlength="150"
          show-word-limit
          type="textarea"
          placeholder="请输入离职原因"
          style="width: 320px; height: 50px"
        />
      </div>

      <div class="click_update_time_button">
        <Button type="primary" @click="click_action_request" :loading="lizhi_loading"
          >确认</Button
        >
      </div>
    </Modal>

    <!-- 更新手机号 -->
    <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
      <div>
        <Input
          maxlength="11"
          v-model="update_phone_value"
          placeholder="输入11位手机号码"
          style="width: 200px"
        />
      </div>
      <div class="update_phone_button">
        <Button type="primary" @click="update_phone">确认更新</Button>
      </div>
    </Modal>

    <update_job_name
      @change="update_job_name_change"
      ref="update_job_name"
    ></update_job_name>

    <resume_detail ref="resume_detail"></resume_detail>
    <interview_update_phone ref="interview_update_phone" @change="interview_update_phone_change"></interview_update_phone>

    <update_remarks @change="update_remarks_change" ref="update_remarks"></update_remarks>
  </div>
</template>

<script>
import update_idcard from "@/views/roster_manage/component/update_idcard2.vue";
import update_job_name from "../roster/update_job_name.vue";
import update_remarks from "../roster/update_remarks.vue";
import interview_update_phone from '@/views/roster_manage/component/update_phone.vue'

import { http, open_new_page } from "@/utils/http.js";
import watermark from "@/utils/shuiyin.js";
import resume_detail from "@/views/roster_manage/component/resume_detail.vue";

export default {
  components: {
    update_idcard,
    update_job_name,
    update_remarks,
    resume_detail,
    interview_update_phone
  },
  props: ["project_id"],
  name: "ruzhi",

  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      table_loading: false,
      columns: [],
      table_data: [],

      page: 1,
      limit: 20,
      total_count: 0,
      tabs_index: "",
      tabs_show: true,
      flow_class_list: [],

      //选项
      action_list: [],
      is_action: false,
      //归属人
      belong_type_list: [],
      //系统用户列表
      sys_user_list: [],
      // 表格选择数据
      table_selection: [],
      search_type: "name",
      search_value: "",

      update_affiliation_show: false,
      update_affiliation_data: {
        belong_type: "B01",
      },

      project_id: "",
      project_name: "",
      tabs_append: "",

      update_time_show: false,
      update_time_data: {},

      lizhi_show: false,
      lizhi_remarks: "",
      lizhi_action_item: {},
      lizhi_loading: false,

      // 更新手机号
      update_phone_show: false,
      update_phone_value: "",
      update_phone_item: {},

      //退保url
      tuibao_url: "",
      tuibao_count: 0,

      button_loading:false
    };
  },

  mounted() {
    this.window_change();
  },

  methods: {
    update_remarks_change() {
      this.get_ruzhi_list();
    },

    click_update_remarks(row) {
      this.$refs.update_remarks.open(this.project_id, row);
    },

    update_job_name_change() {
      this.get_ruzhi_list();
    },

    // 更新岗位
    click_job_name(row) {
      this.$refs.update_job_name.open(this.project_id, row);
    },

    click_update_phone(row) {
      this.$refs.interview_update_phone.open(row)
      
    },
    interview_update_phone_change(){
      this.get_ruzhi_list()
    },


    click_update_time_button() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id: this.update_time_data.interview_id,
        create_time: this.update_time_data.create_time_date.getTime() / 1000,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/ruzhi/update_entry_time",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_ruzhi_list();
            that.update_time_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击更新时间
    click_update_time(row) {
      if (this.tabs_index != "FLOW_B69B9") {
        this.$Message.error("只可以改入职时间哟，离职时间请到离职表修改");
        return;
      }

      this.update_time_data = JSON.parse(JSON.stringify(row));
      this.update_time_data.create_time_date = new Date(
        this.update_time_data.create_time
      );
      this.update_time_show = true;
    },

    click_get_back() {
      var that = this;

      this.$Modal.confirm({
        title: "提示",
        content:
          "<p>返回上一步后当前状态会删除，员工会恢复到上一步【在职】状态，操作后无法恢复，真的要继续吗？</p>",
        onOk: () => {
          that.get_back_affirm();
        },
        onCancel: () => {},
      });
    },

    //返回上一步
    get_back_affirm() {
      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var ivid = this.table_selection[i]["interview_id"];
        interview_id_list.push(ivid);
      }

      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一位");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id_list: interview_id_list,
        flow_id: this.tabs_index,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/get_back", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_ruzhi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open() {
      var query = this.$route.query;
      if (query.flow_id) {
        this.tabs_index = query.flow_id;
      }
      if (query.project_id) {
        this.project_id = query.project_id;
      }
      if (query.project_name) {
        this.project_name = query.project_name;
      }
      if (query.tabs_append) {
        this.tabs_append = query.tabs_append;
      }

      this.create_shuiyin();
      this.get_flow_class_list();
    },

    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard.open(item);
    },

    update_idcard_change() {
      this.get_ruzhi_list();
    },

    click_update_guishu(row) {
      this.get_belong_type();
      // this.update_affiliation_show = true
      // this.update_affiliation_data.belong_type = row.belong_type_status
    },

    //归属人类型
    get_belong_type() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/my_project/ruzhi/belong_type", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.belong_type_list = res.data.type_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => {},
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_ruzhi_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击搜索
    search_click() {
      this.page = 1;
      this.get_ruzhi_list();
    },
    create_shuiyin() {
      var user_info = window.localStorage.getItem("user_info");
      if (user_info) {
        var user_info_dict = JSON.parse(user_info);
        var name = user_info_dict.name;
        watermark.set("保密信息-" + name, "220px");
      }
    },

    //点击小勾
    tabs_selection_change(e) {
      this.table_selection = e;
    },

    click_action(item) {
      if (item.value == "FLOW_B718E") {
        this.lizhi_show = true;
        this.lizhi_action_item = item;
      } else {
        console.log(item);
        var that = this;
        this.$Modal.confirm({
          title: "操作警告",
          content:
            "<p>确认要更新状态为【" +
            item.label +
            "】吗，更新状态将无法修改，强烈建议检查无误后确认！</p>",
          onOk: () => {
            that.click_action_request(item);
          },
          onCancel: () => {},
        });
      }
    },

    //点击操作按钮,下一个流程
    click_action_request() {
      var item = this.lizhi_action_item;

      var interview_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var interview_id = this.table_selection[i]["interview_id"];
        interview_id_list.push(interview_id);
      }
      if (interview_id_list.length == 0) {
        this.$Message.error("请至少选择一位");
        this.lizhi_show = false;
        return;
      }
      if (item.value == "") {
        this.$Message.error("flow_id异常");
        this.lizhi_show = false;
        return;
      }

      if (item.value == "FLOW_B718E") {
        if (this.lizhi_remarks.length < 5) {
          this.$Message.error("请输入5字以上离职原因");
          return;
        }
      }
      var that = this;
      var obj = {
        flow_id: item.value,
        current_flow_id: this.tabs_index,
        interview_id_list: interview_id_list,
        remarks: this.lizhi_remarks,
      };

      this.button_loading=true

      this.lizhi_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/ruzhi/next_flow", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.lizhi_show = false;
            that.get_flow_class_list();

            that.tuibao_count = res.data.tuibao_count;
            that.tuibao_url = res.data.tuibao_url;

            that.$Modal.confirm({
              title: "保险减员提示",
              content:
                "<p>共(" +
                String(that.tuibao_count) +
                ")人离职完成，确认前往保险减员吗？</p>",
              onOk: () => {
                open_new_page(that.tuibao_url);
              },
              onCancel: () => {},
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.lizhi_loading = false;
          that.button_loading = false
        })
        .catch((res) => {
          that.lizhi_loading = false;
          that.button_loading = false

          console.log(res, "请求出错");
        });
    },

    click_new_mianshi_button() {
      this.add_resume_show = true;
      this.get_belong_type();
      this.get_dx_sys_user();
    },

    //系统用户列表
    get_dx_sys_user() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/my_project/ruzhi/dx_sys_user", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.sys_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_tabs(e) {
      this.tabs_index = e;
      this.get_ruzhi_list();
      this.get_action_list();
    },

    //获取流程类
    get_flow_class_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/ruzhi/flow_class_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.flow_class_list = res.data.flow_class_list;
            that.tabs_index = that.flow_class_list[0]["value"];

            that.get_ruzhi_list();
            that.get_action_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //获取按钮列表
    get_action_list() {
      var that = this;
      var obj = {
        flow_id: this.tabs_index,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/ruzhi/action_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.is_action = res.data.is_action;
            that.action_list = res.data.action_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取待入职列表
    get_ruzhi_list() {
      var that = this;
      var obj = {
        page: this.page,
        project_id: this.project_id,
        flow_id: this.tabs_index,
        search_type: this.search_type,
        search_value: this.search_value,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/ruzhi/list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.resume_list;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;
          console.log(res, "请求出错");
        });
    },
    page_change(e) {
      this.page = e;
      this.get_ruzhi_list();
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_name(row) {
      this.$refs.resume_detail.open(row, this.project_id);
    },
  },
};
</script>

<style scoped>
.button_1 {
  display: flex;
  align-items: center;
}
.idcard2{
  color: #0466dd;
  cursor: pointer;
}
.phone_span{
  color: #0466dd;
  cursor: pointer;
}

.name {
  color: #0466dd;
  cursor: pointer;
}

.update_phone_button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.phone_icon {
  font-size: 14px;
  cursor: pointer;
  margin-left: 3px;
}

.phone_icon:hover {
  color: #0073ff;
}

.time_picker {
  display: flex;
  justify-content: center;
}

.click_update_time_button {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.idcard_num {
  cursor: pointer;
}

.idcard_num:hover {
  color: #0466dd;
}

.search_div {
  margin-bottom: 5px;
}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.belong_name {
  color: #0466dd;
  cursor: pointer;
}

.table_div {
  position: relative;
}

.hengxian {
  border-top: 1px dashed #ececec;
  margin: 10px 0;
}

.field_item_box {
  display: flex;
  width: 800px;
  padding-left: 10px;
}

.content_page {
  padding: 8px 0 7px 0;
  text-align: center;
}

.page_tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page_main {
  padding: 0 10px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}

.add_resume_button_opertion {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.field_title {
  width: 100px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}

.button_operation {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  width: 100px;
}
</style>
